var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        background: "#f4fafc",
        "border-top": "1px solid transparent",
        "border-bottom": "1px solid transparent"
      }
    },
    _vm._l(_vm.sortedData, function(symptom) {
      return _c("div", { staticClass: "risk-box" }, [
        _c("div", { staticClass: "content-row" }, [
          _c(
            "div",
            {
              staticClass:
                "content-row content-row-column content-align-center auto-width",
              staticStyle: { "margin-right": ".5rem", "flex-shrink": "0" }
            },
            [
              _c("img", {
                staticClass: "risk-img",
                staticStyle: { "margin-bottom": ".5rem" },
                attrs: { src: symptom.img }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-row-center content-align-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "font-12",
                      style:
                        "margin-right: .2rem; color: " +
                        (!symptom.level
                          ? _vm.levelDes.normal.color
                          : _vm.levelDes[symptom.level].color) +
                        ";"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          !symptom.level
                            ? _vm.levelDes.normal.text
                            : _vm.levelDes[symptom.level].text
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "risk-bar-container",
                      staticStyle: { height: "1rem", width: "2.5rem" }
                    },
                    [
                      _c("canvas", {
                        staticClass: "risk-canvas",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "data-level": !symptom.level
                            ? "normal"
                            : symptom.level
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-row content-row-column" }, [
            _c(
              "div",
              {
                staticClass: "content-row content-row-column",
                staticStyle: { "margin-bottom": ".5rem" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "font-12",
                    staticStyle: { "margin-bottom": ".2rem", color: "#707070" }
                  },
                  [_vm._v("定义")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "font-12", staticStyle: { color: "#777777" } },
                  [_vm._v(_vm._s(symptom.definition))]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "content-row content-row-column" }, [
              _c(
                "span",
                {
                  staticClass: "font-12",
                  staticStyle: { "margin-bottom": ".2rem", color: "#891a16" }
                },
                [_vm._v("危害")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "limit-line-3 font-12 risk-des" }, [
                _c("span", { staticStyle: { color: "#db5a60" } }, [
                  _vm._v("骨骼：")
                ]),
                _c("span", { staticStyle: { color: "#777777" } }, [
                  _vm._v(_vm._s(symptom.harm.bone))
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticStyle: { color: "#db5a60" } }, [
                  _vm._v("肌肉：")
                ]),
                _c("span", { staticStyle: { color: "#777777" } }, [
                  _vm._v(_vm._s(symptom.harm.muscle))
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "arrow down-arrow",
          on: { click: _vm.moreOrLess }
        })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-071df230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-071df230","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RiskDetail.vue
// module id = null
// module chunks = 